import { ModuleUebersicht, type ModuleCfg } from './ModuleUebersicht';

const cfg: ModuleCfg = {
  path: 'baugruppen',
  label: 'Baugruppen',
  breadcrumb: 'Produktion',
  extraColumns: [
    { key: 'lackiert',   label: 'Lack.' },
    { key: 'ral_farbe',  label: 'RAL' },
    { key: 'schweisser', label: 'Schweißer' },
  ],
};

export function Baugruppen() {
  return <ModuleUebersicht cfg={cfg} />;
}
